
export default {
  props: {
    fixtureTeam: {
      type: Object,
      required: true,
    },
    form: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {
      activeFixtureId: null,
      tooltipOpen: true,
    };
  },
  computed: {
    teamName () {
      return this.fixtureTeam.team.teamNames[0].displayName;
    },
    teamLogo () {
      return this.getClubLogo(this.fixtureTeam.team);
    },
  },
  methods: {
    getResultAbbr (fixture) {
      const winner = fixture.winnerFixtureTeamId;
      return fixture.teams.team.id === winner ? `W`
        : winner ? `L` : `D`;
    },
    hoverMatch (match) {
      this.activeFixtureId = match.id;
    },
  },
};
